var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.699382
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.144 29.323H3.17894C1.97541 29.323 1 28.3476 1 27.144V3.17835C1 1.97543 1.97541 1 3.17894 1H27.144C28.3476 1 29.323 1.97543 29.323 3.17835V27.144C29.323 28.3476 28.3476 29.323 27.144 29.323Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66461 28.8509L19.6385 15.418C20.0415 15.076 20.6274 15.076 21.0311 15.418L29.323 23.9345",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49685 7.13666C11.3215 7.13666 12.8012 8.61632 12.8012 10.441C12.8012 12.2657 11.3215 13.7454 9.49685 13.7454C7.67217 13.7454 6.1925 12.2657 6.1925 10.441C6.1925 8.61632 7.67217 7.13666 9.49685 7.13666Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhoto);
export default __webpack_public_path__ + "static/media/no_photo.14c4466576a0a69a21cdf1de07bdbd1c.svg";
export { ForwardRef as ReactComponent };